var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "0.786012in",
    height: "0.419217in",
    viewBox: "0 0 786 419.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M0.02 398.17l58.84 0.01 43.9 -214.78 113.81 235.81c23.52,-48.87 97.18,-220.22 112.77,-237l45.2 215.12 58.72 0.98 -79.54 -398.31 -136.25 288.46 -138.72 -288.16c-31.94,125.68 -53.67,268.97 -78.75,397.86l0.02 0.01z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M593.44 191.57c0,-26.85 -0.16,-53.71 0.08,-80.55 0.08,-8.51 0.38,-10.06 -4.84,-13.84 -9.11,-6.6 -27.22,-18.16 -33.44,-24.63 49.16,0 121.19,-10.67 137.14,33.03 8.34,22.82 4.74,52.01 -8.94,67.12 -19.66,21.72 -57.82,18.87 -90.01,18.87zm-61.14 206.6l60.94 -0.07 0.21 -153.1c6.99,0.22 8.9,1.68 11.98,6.08l51.05 69.17c8.66,11.76 54.82,72.18 57.61,78.72l71.91 0.22c-3.93,-7.59 -9.22,-13.22 -14.34,-20.16l-44.36 -59.66c-5.17,-6.87 -55.14,-72.72 -57.9,-79.45 34.6,-9.7 60.98,-19.75 77.9,-55.33 15.16,-31.9 13.58,-83.48 -2.83,-111.62 -37,-63.42 -124.93,-53.87 -211.57,-53.87l-0.6 379.05 -0 0.02z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.923deb163e3d8d4dae3e76f7aa04ba14.svg";
export { ForwardRef as ReactComponent };